import React, { PureComponent } from "react";

import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import GlobalHeader from "components/GlobalHeader";
import GlobalFooter from "components/GlobalFooter";
import Cascader from "@/components/Cascader";
import { getToken } from "utils/storage";
import { showhtml, getDate } from "utils/methods";
import md5 from "js-md5";
import "./index.scss";

import {
  Alert,
  Icon,
  Tabs,
  Input,
  Form,
  Button,
  Modal,
  Select,
  Row,
  Col,
  Card,
  Radio,
  message,
} from "antd";
import { lte } from "semver";
import { Message } from "element-react";
const FormItem = Form.Item;
const { TabPane } = Tabs;

let phoneReg =
  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
//手机号检验正则

let codeReg =
  /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;

let idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; //身份证正则
export default class Register extends PureComponent {
  state = {
    selectTab: 0,
    count: 60,
    liked: true,
  };
  componentDidMount() {
    //

    // this.getDict();
    this.getDictionaries();
  }
  getDictionaries = () => {
    Http.get(Request.getDictionaries(), { code: "poli_affi_code" }, (obj) => {
      if (obj.code == 200) {
        // message.success('发送成功')
        this.setState({ selectList: obj.data });
      } else {
        message.error(obj.msg ? obj.msg : "请求失败");
      }
    });
  };

  constructor(props) {
    super(props);

    this.state = {
      form: {
        account: "",
        password: "",
        checkPass: "",
        phone: "",
        code: "",
        countyName: "",
        type: "",
        cityId: "",
        clause: "",
        countyId: "",
        cityName: "",
        criterion: [],
      },
      value: "",
      dialogVisible: false,
      count: 60,
      liked: true,
      rules: {
        type: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              var phone = parseInt(value, 10);
              setTimeout(() => {
                if (!Number.isInteger(phone)) {
                  callback(new Error("请输入数字值"));
                } else {
                  if (phone.toString().length != 11) {
                    callback(new Error("请输入正确的手机号码"));
                  } else {
                    callback();
                  }
                }
              }, 1000);
            },
            trigger: "change",
          },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              var code = parseInt(value, 10);

              setTimeout(() => {
                if (!Number.isInteger(code)) {
                  callback(new Error("请输入数字值"));
                } else {
                  callback();
                }
              }, 1000);
            },
            trigger: "change",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入密码"));
              } else {
                if (this.state.form.checkPass !== "") {
                  this.refs.form.validateField("checkPass");
                }
                callback();
              }
            },
          },
        ],
        checkPass: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请再次输入密码"));
              } else if (value !== this.state.form.password) {
                callback(new Error("两次输入密码不一致!"));
              } else {
                callback();
              }
            },
          },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        cityName: [
          { required: true, message: "请选择城市", trigger: "change" },
        ],
        clause: [
          {
            type: "array",
            required: true,
            message: "请勾选同意条款",
            trigger: "change",
          },
        ],
      },
      countyList: "",
      cityList: "",
      provinceId: "",
      phoneNum: "",
      loading: false,
    };
  }
  handleSubmit = (e) => {
    // console.log(e);
    if (e.householdAddress) {
      if (!e.householdAddress.countyId) {
        message.error("所在地选择必须精确到区/县级");
        return;
      } else {
        let idArr = `${e.householdAddress.provinceId},${e.householdAddress.cityId},${e.householdAddress.countyId}`;
        let nameArr = `${e.householdAddress.provinceName},${e.householdAddress.cityName},${e.householdAddress.countyName}`;
        e.orgName = nameArr;
        e.orgId = idArr;
      }
    }
    if (e.password != e.password2) {
      message.error("两次密码输入不一致，请重新输入！");
      return;
    }

    e.password = md5(e.password);
    e.password2 = md5(e.password2);

    let params = {
      ...e,
      account: e.phone,
      userType: 2,
      householdAddress: e.orgName,
      isWillingTrain: e.isWillingTrain,
    };
    // console.log("params", params);

    Http.postJson(Request.getSoldier(), params, (obj) => {
      if (obj.code == 200) {
        message.success("注册成功");
        setTimeout(() => {
          this.props.history.push("/login");
        }, 2000);
      } else {
        message.error(obj.msg ? obj.msg : "注册失败");
      }
    });
  };
  otherSubmit = (e) => {
    if (e.password != e.password2) {
      message.error("两次密码输入不一致！");
      return;
    }
    e.password = md5(e.password);
    e.password2 = md5(e.password2);
    //  auditMechanismType 机构类型 0招聘企业 1培训机构 2金融机构
    // 1退役军人 2招聘企业 3培训机构 4金融机构

    if (e.householdAddress) {
      if (!e.householdAddress.countyId) {
        message.error("地区选择必须精确到县级");
        return;
      } else {
        let idArr = `${e.householdAddress.provinceId},${e.householdAddress.cityId},${e.householdAddress.countyId}`;
        let nameArr = `${e.householdAddress.provinceName},${e.householdAddress.cityName},${e.householdAddress.countyName}`;
        e.auditMechanismLocation = nameArr;
        e.orgId = idArr;
      }
    }

    const { selectTab } = this.state;
    let params = {
      ...e,
      account: e.auditMechanismCode,
      userType: selectTab - 0 + 3,
      auditMechanismType: selectTab - 2,
      householdAddress: e.orgName,
      isWillingTrain: e.isWillingTrain,
    };
    console.log("params", params);
    Http.postJson(Request.otherRegister(), params, (obj) => {
      console.log("obj", obj);
      if (obj.code == 200) {
        message.success("注册成功");
        setTimeout(() => {
          this.props.history.push("/login");
        }, 2000);
      } else {
        message.error(obj.msg ? obj.msg : "注册失败");
      }
    });
  };
  // 获取城市
  getData(pid, type) {
    let params = {
      pid: pid,
    };
    return Http.get(Request.getArea(), params, (obj) => {
      if (obj.code == 200) {
        console.log("getData-obj:", obj);
        if (type == "province") {
          this.setState({
            provinceId: obj.data[0].id,
          });
          this.setState({
            form: Object.assign({}, this.state.form, {
              provinceId: obj.data[0].id,
              provinceNme: obj.data[0].deptName,
            }),
          });
          this.getData(this.state.form.provinceId, "getCityList");
        } else if (type == "city") {
          // 获取区列表
          this.setState({
            countyList: obj.data,
          });
        } else {
          // 获取城市列表
          this.setState({
            cityList: obj.data,
          });
        }
      } else {
        message.error("网络错误，请刷新重试");
      }
    });
  }
  //倒计时
  countDown() {
    const { count } = this.state;
    if (count === 1) {
      this.setState({
        count: 60,
        liked: true,
      });
    } else {
      this.setState({
        count: count - 1,
        liked: false,
      });
      setTimeout(this.countDown.bind(this), 1000);
    }
  }

  //获取短信验证码
  getCode = () => {
    let { phoneNum, liked } = this.state;
    // console.log("phoneNum", phoneNum);

    // validator.isMobilePhone(value)

    if (!phoneNum) {
      message.error("请输入手机号码");
      return;
    } else if (!phoneReg.test(phoneNum)) {
      message.error("请输入正确的手机号码");
      return;
    } else if (!liked) {
      return;
    } else {
      this.setState({ loading: true });
      let params = {
        phone: phoneNum,
      };
      Http.get(
        Request.getDebugUrl() + "blade-portal/registerserver/getSmsCode",
        params,
        (obj) => {
          this.setState({ loading: false });
          console.log("sms==", obj);
          if (obj && obj.code == 200) {
            message.success("发送成功");
            this.countDown();
          } else {
            if (obj.msg != "") {
              message.error(obj.msg);
            } else {
              message.error("发送失败");
            }
            return false;
          }
        }
      );
    }
    // if (!liked) {
    //   return;
    // }
  };

  onChange(key, value) {
    let { countyList, cityList } = this.state;

    this.setState({
      form: Object.assign({}, this.state.form, { [key]: value }),
    });
    if (key == "cityId") {
      this.getData(value, "city");
      for (var i = 0; i < cityList.length; i++) {
        if (cityList[i].id == value) {
          this.setState({
            form: Object.assign({}, this.state.form, {
              [key]: value,
              cityName: cityList[i].deptName,
            }),
          });
        }
      }
    }
    if (key == "countyId") {
      for (var i = 0; i < countyList.length; i++) {
        if (countyList[i].id == value) {
          this.setState({
            form: Object.assign({}, this.state.form, {
              [key]: value,
              countyName: countyList[i].deptName,
            }),
          });
        }
      }
    }
  }

  readCriterion = () => {
    this.setState({
      dialogVisible: true,
    });
  };
  onChange = (key) => {
    console.log(key);
    this.setState({ selectTab: key });
  };

  render() {
    const { value, selectList, liked, count, loading } = this.state;

    const formItemLayout = {
      labelCol: {
        xs: 7,
        md: 7,
        lg: 7,
      },
      wrapperCol: {
        span: 16,
      },
    };
    const formItemLayout2 = {
      labelCol: {
        xs: 8,
        md: 8,
        lg: 8,
      },
      wrapperCol: {
        span: 16,
      },
    };
    return (
      <div>
        <GlobalHeader history={this.props.history} />
        <div className="regBox">
          <div className="conBox">
            <Tabs onChange={this.onChange} type="card">
              <TabPane tab="退役军人注册" key="1">
                <Card bordered={false} className="cardBox">
                  <h2>必填项</h2>
                  <Form onFinish={this.handleSubmit}>
                    <Row gutter={24}>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="姓名"
                          name="realName"
                          rules={[
                            {
                              required: true,
                              message: "请输入姓名",
                              validator: (rule, value, callback) => {
                                if (!value || value.trim() === "") {
                                  callback("请输入姓名");
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入姓名" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="身份证号码"
                          name="idCardNum"
                          rules={[
                            {
                              required: true,
                              // message: '请输入身份证号码',
                              validator: (rule, value, callback) => {
                                if (value && !idCardReg.test(value)) {
                                  callback("请输入正确的身份证");
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入身份证号码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="联系电话"
                          name="phone"
                          onChange={(e) =>
                            this.setState({ phoneNum: e.target.value })
                          }
                          rules={[
                            {
                              required: true,
                              validator: (rule, value, callback) => {
                                if (value && !phoneReg.test(value)) {
                                  callback("请输入正确的手机号码");
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入联系电话" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="政治面貌"
                          name="veteransOutlook"
                          rules={[
                            { required: true, message: "请选择政治面貌" },
                          ]}
                        >
                          <Select placeholder="请输入政治面貌">
                            {selectList
                              ? selectList.map((item, index) => {
                                  return (
                                    <Select.Option
                                      key={index}
                                      value={item.dictKey}
                                    >
                                      {item.dictValue}
                                    </Select.Option>
                                  );
                                })
                              : ""}
                            {/* <Select.Option value={1}>群众</Select.Option>
                            <Select.Option value={2}>团员</Select.Option>
                            <Select.Option value={3}>党员</Select.Option> */}
                          </Select>
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="登录密码"
                          name="password"
                          rules={[
                            { required: true, message: "请输入登录密码" },
                          ]}
                        >
                          <Input type="password" placeholder="请输入登录密码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="确认密码"
                          name="password2"
                          rules={[{ required: true, message: "请输确认密码" }]}
                        >
                          <Input type="password" placeholder="请输确认密码" />
                        </FormItem>
                      </Col>
                      {/* <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="身份类别"
                          name="userType"
                          rules={[
                            { required: true, message: "请输入身份类别" },
                          ]}
                        >
                          <Select placeholder="请选择身份类别">
                            <Select.Option value={2}>退役军人</Select.Option>
                            <Select.Option value={5}>
                              招聘企业用户
                            </Select.Option>
                            <Select.Option value={6}>
                              培训机构用户
                            </Select.Option>
                            <Select.Option value={7}>
                              金融机构用户
                            </Select.Option>
                          </Select>
                        </FormItem>
                      </Col> */}
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="所在地"
                          name="householdAddress"
                          rules={[{ required: true, message: "请输入地址" }]}
                        >
                          {/* <Input placeholder="请输入户籍地址" />  */}
                          <Cascader allCitys meishan bespread></Cascader>
                        </FormItem>
                      </Col>
                      {/* <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="报道机构"
                          name="deptName"
                          rules={[
                            { required: true, message: "请选择报道机构" },
                          ]}
                        >
                          <Select placeholder="请选择报道机构">
                            <Select.Option value={1}>群众</Select.Option>
                            <Select.Option value={2}>团员</Select.Option>
                            <Select.Option value={3}>党员</Select.Option>
                          </Select>
                        </FormItem>
                      </Col> */}
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="验证码"
                          name="smsCode"
                          rules={[{ required: true, message: "请输入验证码" }]}
                        >
                          <div className="checkCode">
                            <div style={{ width: "71%", float: "left" }}>
                              <Input
                                type="text"
                                placeholder="请输入验证码"
                                // onChange={this.onChange.bind(
                                //   this,
                                //   "verificationCode"
                                // )}
                              />
                            </div>
                            <Button
                              type={liked ? "primary" : ""}
                              onClick={this.getCode}
                              style={{ float: "right", width: "27%" }}
                              disabled={!liked}
                              loading={loading}
                            >
                              {liked ? "获取验证码" : count}
                            </Button>
                          </div>
                        </FormItem>
                      </Col>
                      {/* bug 18089 就业创业网门户--首页，取消就业创业网注册时选择是否有培训需求 */}
                      {/* <Col span={24}>
                        <h2>教育培训意向调查</h2>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout2}
                          label="是否愿意参加教育培训"
                          name="isWillingTrain"
                        >
                          <Radio.Group onChange={this.onChange} value={value}>
                            <Radio value={0}>是</Radio>
                            <Radio value={1}>否</Radio>
                          </Radio.Group>
                        </FormItem>
                      </Col> */}
                    </Row>
                    <Row>
                      <Col span={2} offset={9}>
                        <Button
                          block
                          onClick={() => this.props.history.goBack()}
                        >
                          取消
                        </Button>
                      </Col>
                      <Col span={2} offset={2}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ background: "#3356c5" }}
                          block
                        >
                          注册
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card>
              </TabPane>
              {/* <TabPane tab="招聘企业注册" key="2">
                <Card bordered={false} className="cardBox">
                  <h2>基本信息</h2>
                  <Form onFinish={this.otherSubmit}>
                    <Row gutter={24}>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="机构法人"
                          name="auditMechanismLegalPerson"
                          rules={[
                            { required: true, message: "请输入机构法人名称" },
                          ]}
                        >
                          <Input placeholder="请输入机构法人名称" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="联系人"
                          name="auditMechanismContacts"
                          rules={[{ required: true, message: "请输入联系人" }]}
                        >
                          <Input placeholder="请输入联系人" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="统一社会信用代码"
                          name="auditMechanismCode"
                          rules={[
                            {
                              required: true,
                              message: "请输入统一社会信用代码",
                              validator: (rule, value, callback) => {
                                if (value && !codeReg.test(value)) {
                                  callback(
                                    "请输入15或18位正确的统一社会信用代码"
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入统一社会信用代码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="手机号码"
                          name="phone"
                          onChange={(e) =>
                            this.setState({ phoneNum: e.target.value })
                          }
                          rules={[
                            {
                              required: true,
                              validator: (rule, value, callback) => {
                                if (value && !phoneReg.test(value)) {
                                  callback("请输入正确的手机号码");
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入手机号码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="密码"
                          name="password"
                          rules={[{ required: true, message: "请输入密码" }]}
                        >
                          <Input type="password" placeholder="请输入密码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="确认密码"
                          name="password2"
                          rules={[{ required: true, message: "请输入密码" }]}
                        >
                          <Input type="password" placeholder="请输入密码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="所在地"
                          name="householdAddress"
                          rules={[{ required: true, message: "请选择所在地" }]}
                        >
                          <Cascader allCitys meishan bespread></Cascader>
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="验证码"
                          name="smsCode"
                          rules={[{ required: true, message: "请输入验证码" }]}
                        >
                          <div className="checkCode">
                            <div style={{ width: "71%", float: "left" }}>
                              <Input
                                type="text"
                                placeholder="请输入验证码"
                              />
                            </div>
                            <Button
                              type={liked ? "primary" : ""}
                              onClick={this.getCode}
                              style={{ float: "right", width: "27%" }}
                              disabled={!liked}
                              loading={loading}
                            >
                              {liked ? "获取验证码" : count}
                            </Button>
                          </div>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={2} offset={9}>
                        <Button
                          block
                          onClick={() => this.props.history.goBack()}
                        >
                          取消
                        </Button>
                      </Col>
                      <Col span={2} offset={2}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ background: "#3356c5" }}
                          block
                        >
                          注册
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card>
              </TabPane>
              <TabPane tab="培训机构注册" key="3">
                <Card bordered={false} className="cardBox">
                  <h2>基本信息</h2>
                  <Form onFinish={this.otherSubmit}>
                    <Row gutter={24}>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="机构法人"
                          name="auditMechanismLegalPerson"
                          rules={[
                            { required: true, message: "请输入机构法人名称" },
                          ]}
                        >
                          <Input placeholder="请输入机构法人名称" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="联系人"
                          name="auditMechanismContacts"
                          rules={[{ required: true, message: "请输入联系人" }]}
                        >
                          <Input placeholder="请输入联系人" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="统一社会信用代码"
                          name="auditMechanismCode"
                          rules={[
                            {
                              required: true,
                              message: "请输入统一社会信用代码",
                              validator: (rule, value, callback) => {
                                if (value && !codeReg.test(value)) {
                                  callback(
                                    "请输入15或18位正确的统一社会信用代码"
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入统一社会信用代码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="手机号码"
                          onChange={(e) =>
                            this.setState({ phoneNum: e.target.value })
                          }
                          name="phone"
                          rules={[
                            {
                              required: true,
                              validator: (rule, value, callback) => {
                                if (value && !phoneReg.test(value)) {
                                  callback("请输入正确的手机号码");
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入手机号码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="密码"
                          name="password"
                          rules={[{ required: true, message: "请输入密码" }]}
                        >
                          <Input type="password" placeholder="请输入密码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="确认密码"
                          name="password2"
                          rules={[{ required: true, message: "请输入密码" }]}
                        >
                          <Input type="password" placeholder="请输入密码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="所在地"
                          name="householdAddress"
                          rules={[{ required: true, message: "请选择所在地" }]}
                        >
                          <Cascader allCitys meishan bespread></Cascader>
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="验证码"
                          name="smsCode"
                          rules={[{ required: true, message: "请输入验证码" }]}
                        >
                          <div className="checkCode">
                            <div style={{ width: "71%", float: "left" }}>
                              <Input
                                type="text"
                                placeholder="请输入验证码"
                              />
                            </div>
                            <Button
                              type={liked ? "primary" : ""}
                              onClick={this.getCode}
                              style={{ float: "right", width: "27%" }}
                              disabled={!liked}
                              loading={loading}
                            >
                              {liked ? "获取验证码" : count}
                            </Button>
                          </div>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={2} offset={9}>
                        <Button
                          block
                          onClick={() => this.props.history.goBack()}
                        >
                          取消
                        </Button>
                      </Col>
                      <Col span={2} offset={2}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ background: "#3356c5" }}
                          block
                        >
                          注册
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card>
              </TabPane>
              <TabPane tab="金融机构注册" key="4">
                <Card bordered={false} className="cardBox">
                  <h2>基本信息</h2>
                  <Form onFinish={this.otherSubmit}>
                    <Row gutter={24}>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="机构法人"
                          name="auditMechanismLegalPerson"
                          rules={[
                            { required: true, message: "请输入机构法人名称" },
                          ]}
                        >
                          <Input placeholder="请输入机构法人名称" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="联系人"
                          name="auditMechanismContacts"
                          rules={[{ required: true, message: "请输入联系人" }]}
                        >
                          <Input placeholder="请输入联系人" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="统一社会信用代码"
                          name="auditMechanismCode"
                          rules={[
                            {
                              required: true,
                              message: "请输入统一社会信用代码",
                              validator: (rule, value, callback) => {
                                if (value && !codeReg.test(value)) {
                                  callback(
                                    "请输入15或18位正确的统一社会信用代码"
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入统一社会信用代码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="手机号码"
                          onChange={(e) =>
                            this.setState({ phoneNum: e.target.value })
                          }
                          name="phone"
                          rules={[
                            {
                              required: true,
                              validator: (rule, value, callback) => {
                                if (value && !phoneReg.test(value)) {
                                  callback("请输入正确的手机号码");
                                } else {
                                  callback();
                                }
                              },
                            },
                          ]}
                        >
                          <Input placeholder="请输入手机号码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="密码"
                          name="password"
                          rules={[{ required: true, message: "请输入密码" }]}
                        >
                          <Input type="password" placeholder="请输入密码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="确认密码"
                          name="password2"
                          rules={[{ required: true, message: "请输入密码" }]}
                        >
                          <Input type="password" placeholder="请输入密码" />
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="所在地"
                          name="householdAddress"
                          rules={[{ required: true, message: "请选择所在地" }]}
                        >
                          <Cascader allCitys meishan bespread></Cascader>
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          {...formItemLayout}
                          label="验证码"
                          name="smsCode"
                          rules={[{ required: true, message: "请输入验证码" }]}
                        >
                          <div className="checkCode">
                            <div style={{ width: "71%", float: "left" }}>
                              <Input
                                type="text"
                                placeholder="请输入验证码"
                              />
                            </div>
                            <Button
                              type={liked ? "primary" : ""}
                              onClick={this.getCode}
                              style={{ float: "right", width: "27%" }}
                              disabled={!liked}
                              loading={loading}
                            >
                              {liked ? "获取验证码" : count}
                            </Button>
                          </div>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={2} offset={9}>
                        <Button
                          block
                          onClick={() => this.props.history.goBack()}
                        >
                          取消
                        </Button>
                      </Col>
                      <Col span={2} offset={2}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ background: "#3356c5" }}
                          block
                        >
                          注册
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card>
              </TabPane> */}
            </Tabs>
          </div>
        </div>

        <GlobalFooter />
      </div>
    );
  }
}
